<div class="container">
    <div [ngSwitch]="resellerId">
        <h2 *ngSwitchCase="'jpmorgan'" id="app-cross-sell-title">{{title}}</h2>
        <h1 *ngSwitchDefault id="app-cross-sell-title">{{title}}</h1>
    </div>
    <p id="app-cross-sell-description" class="description">{{description}}</p>
    <a id="app-cross-sell-send-mail-button" aur-button [href]="callToAction" *ngIf="callToAction" target="_blank">{{'ARC_COMPOSITE_CROSS_SELL_LEARN_MORE' | translate}}</a>
    <img id="app-cross-sell-image" src="{{imageSource}}" />
</div>